<script lang="ts">
  import { onMount } from 'svelte';
  import { Title, Form, Input, ConfirmActions } from '$shared/components';

  interface Props {
    filename?: string;
    loading?: boolean;
    error?: string;
    onevent?: (payload: any) => void;
  }

  let { filename = '', loading = false, error = $bindable(''), onevent }: Props = $props();

  let newFilename = '';
  let localError = $state('');
  let inputElement: Input = $state();

  let filenameWithoutExt = $derived(filename.split('.').slice(0, -1).join('.'));
  let fileExt = $derived(filename.split('.').pop());

  onMount(() => {
    inputElement?.focus();
    inputElement?.select();
  });

  const onClickCancel = (): void => {
    onevent?.({ type: 'close' });
  };

  const onClickOk = (): void => {
    if (!newFilename || newFilename === filenameWithoutExt) {
      localError = 'Filename cannot be empty or no change made';
      return;
    }
    localError = '';
    onevent?.({ type: 'ok', data: { updatedName: `${newFilename}.${fileExt}` } });
  };

  const onInputChange = (detail: { value: string }): void => {
    newFilename = detail.value.trim();
  };

  const onClickCloseError = (): void => {
    error = '';
    localError = '';
  };
</script>

<div class="rename-file">
  <div class="title"><Title type="h3">Rename file</Title></div>
  <div class="form">
    <Form error={error || localError} onalertclose={onClickCloseError}>
      <div class="input">
        <Input
          bind:this={inputElement}
          name="renameInput"
          value={filenameWithoutExt}
          oninput={onInputChange}
        />
        {#if fileExt}
          <div class="ext">.{fileExt}</div>
        {/if}
      </div>
      <div class="actions">
        <ConfirmActions {loading} okLabel="Rename" oncancel={onClickCancel} onok={onClickOk} />
      </div>
    </Form>
  </div>
</div>

<style>
  .rename-file {
    padding: 24px;
  }

  .form,
  .actions {
    margin-top: 24px;
  }

  .input {
    display: flex;
    align-items: center;
  }
  .input .ext {
    margin-left: 8px;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: var(--grey-dark);
  }
</style>
